import Contextualable from '../../mixins/contextualable'
import Positionable from '../../mixins/positionable'
import Toggleable from '../../mixins/toggleable'
import Routable from '../../mixins/routable'

export default {

  mixins: [Contextualable, Positionable, Routable, Toggleable],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    default: Boolean,
    flat: Boolean,
    floating: Boolean,
    hasBadge: Boolean,
    disabled: Boolean,
    icon: Boolean,
    large: Boolean,
    inverted: Boolean,
    loading: Boolean,
    outline: Boolean,
    round: Boolean,
    square: Boolean,
    skew: Boolean,
    withTriangle: Boolean,
    small: Boolean,
    noHover: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    textLink: Boolean,
    type: {
      type: String,
      default: 'button'
    }
  },

  data() {
    return {
      useContextualTextClasses: this.outline || this.flat || this.textLink
    }
  },

  computed: {

    isRasied () {
      return !this.flat && !this.outline && !this.textLink
    },

    classes () {
      return {
        ...this.$contextualClasses,

        'btn': true,
        'btn--absolute': this.absolute,
        [this.activeClass]: this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.floating,
        'btn--fixed': this.fixed,
        'btn--has-badge': this.hasBadge,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': this.isRasied,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--square': this.square,
        'btn--skew': this.skew,
        'btn--small': this.small,
        'btn--top': this.top,
        'btn--text-link': this.textLink,
        'btn--inverted': this.inverted,
        'btn--with-triangle': this.withTriangle,
        'btn--no-hover': this.noHover,
      } 
    }
  },

  methods: {
    genContent (h) {
      const children = []

      // Root outlet
      if(this.$slots.rootLevel)
        children.push( ...this.$slots.rootLevel )

      // Shape
      if(this.skew)
        children.push( h('div', { class: {...this.$contextualClasses, 'btn__skew-shape skewed new-layer': true} }) )
      
      // Triangle
      if(this.withTriangle)
        children.push( h('span', { class: 'btn__triangle lumo-pink triangle-decorator' }) )   

      // Content
      children.push( h('span', { class: 'btn__content' }, [this.$slots.default]) )



      return children
    },
    genLoader (h) {
      const children = []

      if (!this.$slots.loader) {
        children.push(h('n-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }))
      } else {
        children.push(this.$slots.loader)
      }

      return h('span', { 'class': 'btn__content-loading' }, children)
    }
  },

  render (h) {
    const { tag, data } = this.generateRouteLink()
    const children = []

    if (tag === 'button') {
      data.attrs.type = this.type
    }

    children.push(...this.genContent(h))

    if (this.loading) {
      children.push(this.genLoader(h))
    }

    return h(tag, data, children)
  },
}
